module.exports = __webpack_public_path__ + "fonts/98973fc6d6538f84adf72794bcfe7aee.svg";